import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// Initialize Sentry monitoring (CDN-loaded, config in sentry.ts)
import { initSentry } from './services/monitoring/sentry'
initSentry()

// GA4: platform-level tracking (PWA install, session, web vitals, offline)
import {
  initPWAInstallTracking,
  trackSessionFrequency,
  trackCoreWebVitals,
  initOfflineTracking,
  detectPaymentAbandoned,
} from './utils/ga4'

initPWAInstallTracking()
trackSessionFrequency()
trackCoreWebVitals()
initOfflineTracking()
detectPaymentAbandoned()

// Register service worker for push notifications + pickup versi baru
if ('serviceWorker' in navigator) {
  // sw.ts sudah memanggil skipWaiting() + clients.claim(), jadi service worker baru
  // langsung mengambil alih. TAPI halaman yang terlanjur dimuat tetap menjalankan modul
  // JS LAMA — tidak ada apa pun yang menyuruhnya memuat ulang. Akibatnya user bertahan di
  // bundle lama sampai menutup SEMUA tab.
  //
  // Terbukti 18 Agustus 2026: produksi sudah menyajikan build baru selama ~2,5 jam
  // (index.html + chunk terverifikasi identik dengan hasil build), tapi browser masih
  // merender teks dari bundle lama. Kegagalan senyap: tidak ada error, hanya kode usang.
  const hadController = !!navigator.serviceWorker.controller
  let reloading = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // Instalasi PERTAMA kali juga memicu event ini. Saat itu halaman sudah versi terbaru,
    // jadi reload hanya bikin kedipan tanpa guna — lewati.
    if (!hadController || reloading) return
    reloading = true
    window.location.reload()
  })

  navigator.serviceWorker
    .register('/sw.js')
    .then((registration) => {
      // Tab yang dibiarkan terbuka berjam-jam tidak pernah memeriksa versi baru sendiri.
      // Periksa tiap kali tab kembali terlihat, supaya deploy menyusul tanpa aksi manual.
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') void registration.update()
      })
    })
    .catch(() => {
      // Service worker registration failed silently
    })
}

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Could not find root element to mount to')
}

const root = ReactDOM.createRoot(rootElement)
root.render(
  <App />
)